import { render } from "./index.vue?vue&type=template&id=0876f406&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=0876f406&scoped=true&lang=css"
import "./index.vue?vue&type=style&index=1&id=0876f406&lang=scss&scoped=true"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0876f406"]])

export default __exports__